import React from 'react'
import PropTypes from 'prop-types'
import injectStyles from 'react-jss'

const styles = {
  label: {
    display: 'block',
    padding: 0,
    fontSize: '16px',
    color: '#546b81',
    fontFamily: 'Roboto Regular',
    lineHeight: '24px',
    margin: '0 0 10px 0',
    fontWeight: '700',
  },
}

const FormLabel = ({ label, classes }) => (
  <div className={classes.label}>{label}</div>
)

FormLabel.propTypes = {
  message: PropTypes.string.isRequired,
}

export default injectStyles(styles)(FormLabel)



// WEBPACK FOOTER //
// ./src/Components/Form/FormLabel/index.js